import { useState, useEffect } from "react";
import { BorderBox, Timeline, Spinner } from "../components/index.js";
import requestHandler from "../utils/requestHandler.js";

export default function Degrees() {
  const [degrees, setDegrees] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadDegrees = async () => {
      setLoading(true);
      const res = await requestHandler({
        path: "degrees",
        method: "POST",
        body: { slug: "all" },
      });

      if (res.success) {
        const sortedDegrees = res.data.sort((a, b) => a.id - b.id);
        setDegrees(sortedDegrees);
      } else {
        console.error("Error loading degrees:", res.error);
      }
      setLoading(false);
    };

    loadDegrees();
  }, []);

  return (
    <div className="flex flex-col lg:flex-row gap-4 pb-4 lg:h-[calc(100vh-4rem)]">
      <div className="w-full lg:w-1/4 lg:h-full">
        <BorderBox
          overflow={false}
          className="lg:overflow-y-auto"
          padding="p-0"
        >
          <div className="h-full">
            {loading ? (
              <Spinner />
            ) : (
              <Timeline degree={degrees[0]} clickableTitle />
            )}
          </div>
        </BorderBox>
      </div>

      <div className="w-full lg:w-1/4 lg:h-full">
        <BorderBox
          overflow={false}
          className="lg:overflow-y-auto"
          padding="p-0"
        >
          <div className="h-full">
            {loading ? (
              <Spinner />
            ) : (
              <Timeline degree={degrees[1]} clickableTitle />
            )}
          </div>
        </BorderBox>
      </div>

      <div className="w-full lg:w-1/4 lg:h-full">
        <BorderBox
          overflow={false}
          className="lg:overflow-y-auto"
          padding="p-0"
        >
          <div className="h-full">
            {loading ? (
              <Spinner />
            ) : (
              <Timeline degree={degrees[2]} clickableTitle />
            )}
          </div>
        </BorderBox>
      </div>

      <div className="w-full lg:w-1/4 lg:h-full">
        <BorderBox
          overflow={false}
          className="lg:overflow-y-auto"
          padding="p-0"
        >
          <div className="h-full">
            {loading ? (
              <Spinner />
            ) : (
              <Timeline degree={degrees[3]} clickableTitle />
            )}
          </div>
        </BorderBox>
      </div>
    </div>
  );
}
